import { mockQuoteDetails } from '@domgen/dgx-fe-basket';
import {
  mockCustomerAddressDetails,
  mockCustomerDetails,
} from '@domgen/dgx-fe-common';
import { WorldpayRedirectRequest } from '../../models/worldpay/worldpay-redirect-request.interface';
import { mockWorldpayConfig } from './worldpay-config.mock';

export const mockWorldpayRedirectRequest: WorldpayRedirectRequest = {
  address: mockCustomerAddressDetails,
  amount: 10,
  billingAddress: mockCustomerAddressDetails,
  companyCode: mockQuoteDetails.companyCode,
  description: mockWorldpayConfig.transactionDescription,
  email: mockCustomerDetails.email?.main ?? '',
  name: `${mockCustomerDetails.firstName} ${mockCustomerDetails.surname}`,
  schemeCode: mockQuoteDetails.schemeCode,
  transactionSource: mockWorldpayConfig.transactionSource,
  transactionType: mockWorldpayConfig.transactionType,
};
